<template>
    <div id="description">

    </div>
</template>

<script>
    export default {
        props: ['data'],

        data() {
            return {
                news: null,
                page: 2,
                perPage: 6
            }
        },

        created() {
            this.news = this.data;
            console.log(this.news);
        },
        mounted() {
            document.getElementById("description").innerHTML = this.news.description;
        }

    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/RichTextComponent.vue